import React, { useState, useEffect } from 'react';
import './App.css'
import { space6 } from './dist/helpers'
import { LandingPage } from './dist/LandingPage'
import { getCounter } from './api.jsx'
import { LoadingSpinner } from './dist/LoadingComponent'

function App(props) {
  console.log("Welcome to Andrew Dilks .com!!")
  const { dark, userData } = props;
  const isAndrew = userData?.username === "Andrew_Dilks";
  const [visits, setVisits] = useState("loading");

  useEffect(() => {
    getCounter().then(count => {
      setVisits(count);
    });
  }, []); // Empty dependency array means it runs once on mount

  return (
    <>
      <div>
        <>
          <center>
            <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
              <h1> Number visits: {visits === "loading" ? (<></>): (visits) } </h1>
              { visits === "loading" ? (<LoadingSpinner />): (<></>)}
            </div>
          </center>
        </>
        {isAndrew && (
          <center>
            <div style={{ marginBottom: "1rem" }}>
              <a href="https://api.andrewdilks.com/map" className="btn btn-light btn-lg" style={{ marginRight: "1rem" }}>API Map</a>
              <a href="https://api.andrewdilks.com/logs" className="btn btn-light btn-lg">API Logs</a>
            </div>
          </center>
        )}
        { LandingPage(dark) }
        { space6 }
        { space6 }
      </div>
    </>
  )
}

export default App;
